export enum EntityType {
  UNKNOWN = "UNKNOWN",
  COMPANY = "COMPANY",
  LOCATION = "LOCATION",
  LC_COMMUNICATION = "LC_COMMUNICATION",
  OTHERS = "OTHERS",
}

export enum Role {
  L1 = 1,
  L2 = 2,
  L3 = 3,
  L4 = 4,
}

export enum Module {
  UNKNOWN = "UNKNOWN",
  FORMS_SURVEYS = "FORMS_SURVEYS",
  KOLLAB_SUPPORT = "KOLLAB_SUPPORT",
  HOMEPAGE = "HOMEPAGE",
  BILLING = "BILLING",
  CUSTOM_OFFERS = "CUSTOM_OFFERS",
  REQUEST_LOGS = "REQUEST_LOGS",
  LC_EMAIL = "LC_EMAIL",
  AFFILIATE = "AFFILIATE",
  AGENCY_CREDITS = "AGENCY_CREDITS",
  COMPANY = "COMPANY",
  ISV = "ISV",
  RESELLING = "RESELLING",
  ONBOARDING = "ONBOARDING",
  SAAS = "SAAS",
  BLADE_PLATFORM = "BLADE_PLATFORM",
  MARKETPLACE_APP_SUPPORT = "MARKETPLACE_APP_SUPPORT",
  WORDPRESS = "WORDPRESS",
  YEXT = "YEXT",
  LAUNCHPAD = "LAUNCHPAD",
  LC_DOMAIN = "LC_DOMAIN",
  SUPPORT_AI = "SUPPORT_AI",
  LEGAL = "LEGAL",
  TOURGUIDE = "TOURGUIDE",
  WHATSAPP = "WHATSAPP",
  AI_WRAPPER = "AI_WRAPPER",
  PREMIUM_SUPPORT = "PREMIUM_SUPPORT",
}
